import gestionErreur from '@/services/general/gestionErreur';
import * as clientConfig from '@/configuration/clientConf';
import * as types from './clients-mutation-type';
import * as allTypes from '../mutation-type';
import { browseClients } from '../../api/clients/index';


function initialState() {
  return {
    clients: false,
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
  [types.SET_CLIENTS](state, clients) {
    state.clients = clients;
  },
};

const actions = {
  prechargementClients: ({ commit }) => {
    return new Promise((resolve, reject) => {
      browseClients(clientConfig.TYPE_CLIENT, clientConfig.SOUS_TYPE).then((response) => {
        commit(types.SET_CLIENTS, response.data);
        resolve();
      }).catch((e) => {
        reject(e.code);
        gestionErreur('Erreur lors de la récupération des clients', e);
      });
    });
  },
};

const getters = {
  clients: (state) => {
    return state.clients;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/clients.js